<div class="tabs-container">
  <ul class="tabs-list m-0 p-0 list-unstyled d-flex">
    @for (tab of tabs; track tab; let i = $index) {
      <li class="tab-item flex-fill text-center"
        [class.active]="i === activeIndex" [class.disabled]="tab.disabled" (click)="selectTab(i)">
        <span class="tab-content-wrapper">
          @if (tab.icon) {
            <i [class]="tab.icon" class="tab-icon"></i>
          }
          <span class="tab-label">{{ tab.label }}</span>
        </span>
      </li>
    }
  </ul>
</div>